module.exports = __webpack_public_path__ + "fonts/GothamSSm-Bold_Web.644a1ee.woff2";